import { render } from "./ProhorMessage.vue?vue&type=template&id=406a5520&scoped=true"
import script from "./ProhorMessage.vue?vue&type=script&lang=js"
export * from "./ProhorMessage.vue?vue&type=script&lang=js"

import "./ProhorMessage.vue?vue&type=style&index=0&id=406a5520&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406a5520"]])

export default __exports__